<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- 全局加载指示器 -->
    <div v-if="isLoading" class="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-80">
      <div class="flex flex-col items-center space-y-4">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
        <p class="text-gray-600">載入中...</p>
      </div>
    </div>

    <!-- 路由视图 - 無滑動動畫 -->
    <router-view />

    <!-- 全局通知 -->
    <Teleport to="body">
      <div id="notifications" class="fixed top-4 right-4 z-50 space-y-2">
        <!-- 通知组件将在这里渲染 -->
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { useAppStore } from '@/stores/app'

  const router = useRouter()
  const appStore = useAppStore()
  
  const isLoading = ref(false)

  // 路由加载状态管理
  router.beforeEach((to, from, next) => {
    isLoading.value = true
    next()
  })

  router.afterEach(() => {
    setTimeout(() => {
      isLoading.value = false
    }, 300)
  })

  onMounted(() => {
    // 初始化应用
    appStore.initialize()
  })
</script>

<style scoped>
  /* 無滑動動畫 */
</style>